import application_settings from '../applicationSettings';
import Event from './Event';

class UserProfileEdit extends Event {
    eventName = 'oms_userProfileEdit';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for User profile edit
     * 
     * @param {string} data.name -  name of the customer
     * @param {string} data.calling_code -  calling_code of the customer
     * @param {string} data.contact_no - contact_no of the customer
     * @param {string} data.address - address of the customer
     * @param {string} data.state - state of the customer
     * @param {string} data.country - country of the customer
     * @param {string} data.city - city of the customer
     * @param {string} data.zip - zip of the customer
     * @param {string} data.more_info - custom fields of the customer
     * @return void
     *  
     */
    eventFunction(data) {
        
        let clientId = data.client_id;
        let name = data.name;
        let calling_code = data.calling_code;
        let contact_no = data.contact_no;

        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (name && calling_code && contact_no) {

            // request data
            data.endPoint = application_settings.endPoints.userProfileEdit;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                client_id: clientId,
                name: name,
                calling_code: calling_code,
                contact_no: contact_no,
                address: data.address,
                state: data.state,
                country: data.country,
                city: data.city,
                zip: data.zip,
                more_info: (data.more_info) ? JSON.stringify(data.more_info) : null,
                email:data.email
            };
    
            // send request
            this.sendRequest(data, function (response) {
              if (response) {
    
                //format response data
                let data = thisObj.formatResponseData(response);
    
                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "name & calling_code & contact_no is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default UserProfileEdit;